import { EDistributionGroupName } from '@/config/enums'

export const en = {
  /**
   * ? Product name
   */
  'product.name.cyber-backup': 'Cyber Backup',
  'product.edition.advanced': 'Advanced edition',
  'product.edition.standard': 'Standard edition',

  // ? Words
  'word.search': 'Search',

  // ? Dictionary
  'dictionary.key-count': '0 keys | {count} key | {count} keys',

  // ? Modals
  'modal.product-key.header.title': 'Key',
  'modal.adding-editing-comment.header.adding.title': 'Adding a comment',
  'modal.adding-editing-comment.header.editing.title': 'Editing a comment',
  'modal.header.title.contact-to-support': 'Contacting tech support',
  'modal.download-product.header.title': 'Download distribution: {name}',
  'modal.transfer-privileges.no-admins.description':
    'Add at least one administrator to transfer superadministrator rights',
  'modal.transfer-privileges.description':
    'Super admin rights will be transferred to the administrator',
  'modal.transfer-privileges.select-admin.description':
    'Select the administrator to whom you want to transfer super administrator rights',
  'modal.transfer-privileges.required-password':
    'Enter the password for confirmation',
  'modal.transfer-licenses.title': 'Transfer of keys to another owner',
  'modal.feedback-support.title': 'Thank you!',
  'modal.feedback-support.description':
    'Appeal No. {issueId} has been registered.\n' +
    'We will contact you shortly.\n' +
    'You can track the status of your appeal in the list of appeals.',

  /**
   * ? COMPONENT: Notify
   */
  'component.notify.message-success.company-updated':
    'Information on {name} has been changed',
  'component.notify.message-success.copy-serial-id': 'Serial key copied',
  'component.notify.message-error.copy-serial-id':
    'Failed to copy the serial key',
  'component.notify.message-success.branch-added': 'Added a branch: {name}',
  'component.notify.message-success.branch-deleted': 'Deleted branch: {name}',
  'component.notify.message-success.person-deleted': 'Removed {role}: {name}',
  'component.notify.message-success.person-added': 'Added {role}: {name}',
  'component.notify.message-error.branch-adding':
    'An error occurred while adding a branch',
  'component.notify.message-error.branch-already-added':
    'The {name} branch has already been added',
  'component.notify.message-success.transfer-privileges':
    'Superadmin rights have been transferred to the administrator: {name}',
  'component.notify.message-success.save-comment': 'Comment saved',
  'component.notify.message-error.save-comment': 'Failed to save comment',
  'component.notify.message-success.clear-comment': 'Comment cleared',

  /**
   * ? Edition staff
   */
  'edition.staff.name.mailbox': 'Mailbox',
  'edition.staff.name.mailbox-5': 'Mailbox • 5 mailboxes',
  'edition.staff.name.mailbox-25': 'Mailbox • 25 mailboxes',
  'edition.staff.name.mailbox-50': 'Mailbox • 50 mailboxes',
  'edition.staff.name.mailbox-100': 'Mailbox • 100 mailboxes',
  'edition.staff.name.mailbox-500': 'Mailbox • 500 mailboxes',
  'edition.staff.name.mailbox-1000': 'Mailbox • 1000 mailboxes',
  'edition.staff.name.workstation': 'Workstation',
  'edition.staff.name.virtual-host': 'Virtual Host',
  'edition.staff.name.server': 'Server',
  'edition.staff.name.universal-license': 'Universal',
  'edition.staff.name.postgresql': 'PostgreSQL',

  /**
   * ? FIELDS: label
   */

  'field.label.name:': 'Name:',
  'field.label.search': 'Search',
  'field.label.order:': 'Order:',
  'field.label.email:': 'Email:',
  'field.label.data:': 'Data:',
  'field.label.address:': 'Address:',
  'field.label.branch:': 'Branch:',
  'field.label.phone': 'Phone',
  'field.label.phone:': 'Phone:',
  'field.label.company': 'Company',
  'field.label.country:': 'Country:',
  'field.label.surname:': 'Surname:',
  'field.label.product': 'Product',
  'field.label.user': 'User',
  'field.label.contact-details': 'Contact details',
  'field.label.attached-files': 'Attached files',
  'field.label.generated:': 'Generated:',
  'field.label.subscription-period:': 'Subscription period:',
  'field.label.person': 'Contact person',
  'field.label.email': 'Email',
  'field.label.owner': 'Owner',
  'field.label.owner:': 'Owner:',
  'field.label.contacts': 'Contacts',
  'field.label.status': 'Status',
  'field.label.branch': 'Branch',
  'field.label.created': 'Created',
  'field.label.appeal': 'Appeal',
  'field.label.order-number': 'Order number',
  'field.label.problem-description': 'Problem description',
  'field.label.subject-of-address': 'Subject of address',
  'field.label.commentary': 'Commentary',

  /**
   * ? FORMS: label
   */
  'form.field.label.inn': 'INN',
  'form.field.label.unp': 'UNP',
  'form.field.label.kpp': 'KPP',
  'form.field.label.ogrn': 'OGRN',
  'form.field.label.oked': 'OKED',
  'form.field.label.company': 'Company',
  'form.field.label.main-company': 'Main company',
  'form.field.label.branch': 'Branch',
  'form.field.label.key': 'Key',
  'form.field.label.keys': 'Keys',
  'form.field.label.generated': 'Generated',

  /**
   * ? Buttons: label
   */
  'button.group.all': 'All',
  'button.group.only-my': 'Only my',
  'button.action.clear': 'Clear',
  'button.action.change': 'Change',
  'button.action.add': 'Add',
  'button.action.save': 'Save',
  'button.action.cancel': 'Cancel',
  'button.action.copy': 'Copy',
  'button.action.edit': 'Edit',
  'button.action.transfer': 'Transfer',
  'button.action.browse-all': 'View all',
  'button.action.download-keys': 'Download keys',
  'button.action.hide-comments': 'Hide comments',
  'button.action.show-comments': 'Show comments',
  'button.action.to appeals': 'Go to appeals',
  'button.action.add-admin': 'Add admin',
  'button.action.add-comment': 'Add comment',
  'button.action.edit-comment': 'Edit comment',
  'button.action.clear-comment': 'Clear comment',
  'button.action.transfer-to-person': 'Transfer to another owner',
  'button.action.contact-technical-support': 'Contact technical support',

  /**
   * ? Breadcrumbs
   */
  'breadcrumbs.issue.title': 'Contacting tech support',

  /**
   * ? FIELDS: validate
   */
  'form.field.validate.is-boolean': 'Inadmissible field.',
  'form.field.validate.distribution.is-description':
    'Title already exists in the list of distributions in the «{section}» section',
  'form.field.validate.company-required': 'Choose a company.',

  /**
   * ? FIELDS placeholder
   */
  'field.placeholder.select.search-company': 'Search by name, TIN and address',

  /**
   * ? COMPONENT: Tag
   */
  'component.tag.name.trial-license': 'Trial',
  'component.tag.name.perpetual-license': 'Perpetual',
  'component.tag.name.its-you': "It's you",

  /**
   * ? COMPONENT: Buttons
   */
  'component.button.name.documentation': 'Documentation',
  'component.button.name.buy-full-version': 'Buy full version',
  'component.button.name.buy': 'Buy',
  'component.button.name.download-distribution': 'Download distribution',
  'component.button.name.close': 'Close',
  'component.button.name.add': 'Add',
  'component.button.transfer-privileges': 'Transfer super admin privileges',

  /**
   * ? COMPONENT: Select
   */
  'component.select.search.title.company-example':
    'Example search (up to 20 results are displayed):',
  'component.select.search.text.company-name':
    'Romashka LLC, 1234567890, St. Petersburg',

  /**
   * ? COMPONENT: Table
   */
  'component.table.cell.unlimited': 'Unlimited',
  'component.table.cell.perpetual-key': 'perpetual',
  'component.table.cell.order': 'Order {number}, {period}, {date}',

  /**
   * ? COMPONENT: Buttons
   */
  'component.button.name.next': 'Next',
  'component.button.name.back': 'Back',
  'component.button.name.cancel': 'Cancel',
  'component.button.name.try': 'Try',
  'component.button.name.re-enter': 'Re-enter',
  'component.button.name.buy-key': 'Buy a key',

  /**
   * ? COMPONENT: Stepper
   */
  'stepper.name.type-of-contact': 'Type of request',
  'stepper.name.contact-details': 'Contact details',
  'stepper.name.reporting-problem': 'Reporting a problem',
  'stepper.description.data-pre-filled':
    'Your data has been pre-filled. Check the correctness of the entered data and in case of an error change them in your Profile.',
  'stepper.description.select-product':
    'Select the product where the problem occurred. This will solve your issue faster.',
  'stepper.description.your-problem': 'Describe your problem',

  /**
   * ? COMPONENT: Popover
   */
  'component.popover.distribution.title': 'To use the trial version',
  'component.popover.distribution.download': '1. Download the distribution kit',
  'component.popover.distribution.install':
    '2. Install the product and activate the trial version in the product',

  /**
   * ? COMPONENT: Header
   */
  'component.header.title.products': 'Products',
  'component.header.title.undefined': 'Section not found',
  'component.header.title.personal-account': 'Personal account',
  'component.header.title.no-admins': 'There are no administrators',

  /**
   * ? COMPONENT: Tabs
   */
  'component.tab.short.contacting-support': 'In support',
  'component.tab.short.contacting-sales-department': 'In sales',
  'component.tab.contacting-support': 'Contacting tech support',
  'component.tab.contacting-sales-department':
    'Contacting the sales department',

  /**
   * ? PAGE: Error
   */
  'page.errors.title.account-type-not-found': 'Account type not defined',

  /**
   * ? PAGE: Products
   */
  'page.products.card.title.no-key': "You don't have a key yet",
  'page.products.keys': 'Product keys',
  'page.products.order-number': 'Order number',
  'page.products.subscription-period': 'Subscription period',
  'page.products.card.title.try-product': 'You want to try the product',
  'page.products.card.text.perpetual-license':
    'Purchase a perpetual or subscription-based license',
  'page.products.card.text.trial-version':
    'Select a product and get access to a fully functional trial version',

  /**
   * ? PAGE: Issues (support)
   */
  'page.issues.empty-content.title': 'You have no hits right now',

  /**
   * ? PAGE: Distributions
   */
  'page.distributions.product-list': 'List of products',
  'page.distributions.versions:': 'Versions:',
  [EDistributionGroupName.OTHER]: 'Other',
  [EDistributionGroupName.INSTALLERS]: 'Installers',
  [EDistributionGroupName.VIRTUALIZATION_AGENT]: 'Virtualization agent',
  [EDistributionGroupName.AGENT_UPGRADE_PACKAGE]: 'Agent upgrade package',
  /**
   * ? PAGE: Profile
   */
  'page.profile.button.remove-profile': 'Delete profile',
  'page.profile.button.add-branch': 'Add branch',
  'page.profile.edit-company.title': 'Changing company information',
  'page.profile.edit-branch.title': 'Changing branch information',
  'page.profile.add-branch.title': 'Adding a branch',
  'page.profile.remove-branch.title': 'Delete the branch?',
  'page.profile.remove-person.title': 'Delete the contact person?',
  'page.profile.add-person.title': 'Adding a contact person',
  'page.profile.remove-branch.description':
    'The deletion of a branch is irreversible. Enter your password to confirm.',
  'page.profile.remove-branch.license-description':
    'There are individuals in the branch who may have keys assigned to them. All unactivated accounts will be deleted from your structure.',
  'page.profile.remove-person.description':
    'Deleting a contact person is irreversible. Enter the password to confirm.',
  'page.profile.remove-branch.action-move': 'Transfer to the main company',
  'page.profile.remove-person.license-description':
    'The vacated keys will be turned over to the super administrator',
  'page.profile.not-specified': 'Not specified',
  'page.profile.company-unselected': 'Unselected company',
  'page.profile.empty-contacts': 'No company contact persons have been added',
  'page.profile.can-add-admins':
    'You can add administrators and users and then pass keys to them',
  'page.profile.cell.requisites': 'Requisites',
  'page.profile.cell.company-branches': 'Company branches',
  'page.profile.cell.company-persons': 'Contact persons',
  'page.profile.show-more': 'Show more',
  'page.profile.add-person.description':
    'Administrator can add other administrators, users and distribute keys among them',
  /**
   * ? Roles
   */
  'role.user': 'User',
  'role.admin': 'Admin',
  'role.super-admin': 'Super Admin',
}
